import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient, ConvertParamsToFormData } from "~/utils";

import {
  ResponseMessageType,
  RawDraftContentState,
  PreviewWithFileType,
} from "~/domains";

type RequestDataType = {
  id: string;
  insightPostId: string;
  body: {
    content: RawDraftContentState;
    attachFiles: PreviewWithFileType[];
    quotePostId?: string;
  };
};

const request = ({ id, insightPostId, body }: RequestDataType) => {
  const formData = ConvertParamsToFormData({ reply: body });
  return new ApiClient()
    .put<ResponseMessageType>(
      `/api/members/insight_posts/${insightPostId}/insight_post_comments/${id}`,
      formData,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisInsightPostsInsightPostCommentsUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation(request, { ...options });
};
